function detectButton(selector, callback) {
  const button = document.querySelector(selector);
  if (button) {
    button.addEventListener("click", callback);
  }
}

module.exports = { detectButton };
